import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Column from '../../../layout/Column'
import Columns from '../../../layout/Columns'
import Dates from './components/Dates'
import styles from './styles.module.scss'
import { Formik, Field, Form } from 'formik'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import Button from '../../../elements/Button'
import { useAuthContext } from '/providers/authProvider'
import IconExternal from '/public/icons/icon-external.svg'
import { useSearchContext } from '/providers/SearchContext'
import Card from '/components/pages/single-property/components/Card'
import { withModifiers } from '../../../helpers/withModifiers'
import { useRouter } from 'next/router'

const Availability = ({
  bottomRef,
  property,
  minNights,
  title,
  note,
  description,
  variant,
  translations,
  cardTranslation,
  ...props
}) => {
  const { isTablet, isMobile } = useResponsive()
  const { isAuthorized } = useAuthContext()
  const { search } = useSearchContext()
  const router = useRouter()

  return (
    <Section variant={variant}>
      <Container>
        <Columns columnRef={bottomRef}>
          <Column spans={isMobile ? 12 : isTablet ? 8 : 6}>
            {title && <h2 className={styles.title}>{title}</h2>}

            {note && <div className={styles.note}>{note}</div>}

            {description && (
              <div dangerouslySetInnerHTML={{ __html: description }}></div>
            )}

            {minNights && (
              <div className={styles.nights}>
                <span>{minNights}</span>{' '}
                {translations.welcome.card?.minNights[router.locale]}
              </div>
            )}

            <div className={styles.wrapper}>
              {isTablet && props.blockedDates && (
                <div
                  className={withModifiers(
                    'booking',
                    [search.startDate && search.endDate && 'is-visible'],
                    styles
                  )}
                >
                  <Card
                    translations={cardTranslation}
                    variant={['simple']}
                    blockedDates={props.blockedDates}
                    expandable
                    header={false}
                    property={property}
                    minNights={minNights}
                  />
                </div>
              )}

              {props.blockedDates && property && (
                <div className={styles.calendar}>
                  <Formik
                    initialValues={{
                      startDate: '',
                      endDate: ''
                    }}
                  >
                    {() => (
                      <Form>
                        <Field
                          {...props}
                          translations={translations.availability}
                          property={property}
                          minNights={minNights}
                          component={Dates}
                        />
                      </Form>
                    )}
                  </Formik>

                  {isAuthorized && property && property?.attachment?.calendar && (
                    <Button
                      href={property.attachment.calendar}
                      appendIcon={<IconExternal />}
                      target="_blank"
                      className={styles.calendar__button}
                      variant={['label']}
                    >
                      {translations?.availability?.subscribe[router.locale]}
                    </Button>
                  )}
                </div>
              )}
            </div>
          </Column>
        </Columns>
      </Container>
    </Section>
  )
}

export default Availability
